import { render, staticRenderFns } from "./BulkAddTagsModal.vue?vue&type=template&id=2a851ea2"
import script from "./BulkAddTagsModal.vue?vue&type=script&lang=js"
export * from "./BulkAddTagsModal.vue?vue&type=script&lang=js"
import style0 from "./BulkAddTagsModal.vue?vue&type=style&index=0&id=2a851ea2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports